<template>
    <div id="subpage">
        <el-col :span="24" class="warp-breadcrum">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>
                    <b>首页</b>
                </el-breadcrumb-item>
                <el-breadcrumb-item to="/doctor/index">我的课程</el-breadcrumb-item>
                <el-breadcrumb-item>资料下载</el-breadcrumb-item>
            </el-breadcrumb>
            <el-button size="small" class="reback" type="primary" icon="el-icon-refresh-left" @click="back()">返回列表
            </el-button>
        </el-col>
        <div class="content">
            <div class="xcx-head">
                <div style="display: flex">
                    <span>随堂资料下载</span>
                </div>
            </div>
            <div class="xcx-content" v-loading="loading">

                <div class="box-border pt25 pb25 border-b-s flex text-default">
                    <div class="w300 mr20">
                        <img class="thumb_images" :src="courseInfo.thumb" alt="">
                    </div>
                    <div class="x">
                        <div class="mb10">
                            <span class="text-default ft26">{{ courseInfo.title }}</span>
                            <div class="inline-block ml10 border border-solid bdr6 ft18 pd5">
                                {{ courseInfo.total }}课时</div>
                        </div>
                        <div class="flex mb40">
                            <div class="ft14 text-tags pl10 pr10 pd5 bdr4 border-tags mr10">
                                {{ courseInfo.pattern_name }}</div>
                            <div class="ft14 text-6581A0 pl10 pr10 pd5 bdr4 border-sub mr10">
                                {{ courseInfo.subject_name }}</div>
                        </div>
                        <div class="flex">
                            <img class="wh48 rounded-full mr15" :src="teacherInfo.thumb" alt="">
                            <div class="">
                                <h4 class="text-default ft16 mb10">主讲老师：{{ teacherInfo.title }}</h4>
                                <p class="text-info-light ft14">老师介绍：{{ teacherInfo.speaker }}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <el-empty :image-size="200" v-if="tableData.length == 0"></el-empty>
                <div style="display: flex;flex-wrap: wrap;justify-content: space-between;" v-else>
                    <div class="data-item h900 dis_jcsb border-bottom cur_p flex" v-for="(v, i) in tableData" :key="i">
                        <div class="flex txt-6F8199 font16 col7">
                            <img class="w42 mr25" src="../../../public/images/icon/21.png" alt="" />
                            <div class="col1">
                                <div class="data-item-title txt-233650 font16 truncate">
                                    <el-tag type="primary" size="small" v-if="v.print == 1">打印版</el-tag>
                                    <el-tag type="danger" size="small" v-if="v.print == 0">原版</el-tag>
                                    {{ v.title }}
                                </div>
                                <div class="txt-9097AB font14 mt15">
                                    <span class="mr60">更新时间：{{ v.updated_at }}</span>
                                    <span class="mr60">{{ v.size }}</span>
                                    <!-- <span>下载数：{{ v.click }}</span> -->
                                </div>
                            </div>
                        </div>
                        <div class="">
                            <el-button @click="downLoadFile(v, 0)" type="primary" round icon="el-icon-view">预览
                            </el-button>
                            <el-button @click="downLoadFile(v, 1)" type="danger" round icon="el-icon-download">下载
                            </el-button>
                        </div>
                    </div>

                    <!--分页-->
                    <div class="paging">
                        <el-pagination class="left" @current-change="handleCurrentChange" :current-page="page"
                            background layout="total, prev, pager, next" :total="count" :page-size="limit">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: true,
            tableData: [],
            courseInfo: [],
            teacherInfo: [],
            page: 0,
            count: 0,
            limit: 10,
            id: 0,
        };
    },

    //进入页面加载
    mounted: function () {
        var that = this;
        var query = that.$route.query;
        if (query.course_id) {
            that.id = query.course_id;
            that.getList();
            that.getDetail();
        }
    },
    methods: {
        downLoadFile(v, s) {
            let that = this;
            that.axios.post("/getDownloadUrl", { id: v.id }).then((res) => {
                if (res.code == 200) {
                    if (s == 1) {
                        window.open(res.data.urls);
                    } else {
                        window.open(res.data.filepath);
                    }
                } else {
                    that.$message({
                        type: "error",
                        message: `操作提示: ${res.msg}`,
                    });
                    return;
                }
            });
        },

        /**
         * 获取列表
         */
        getDetail() {
            let that = this;
            that.axios.post("/getCourseDetails", { id: that.id }).then((res) => {
                if (res) {
                    that.courseInfo = res.data;
                    that.teacherInfo = res.data.teacher;
                }
            });
        },

        /**
         * 下一页
         */
        handleCurrentChange(currentPage) {
            var that = this;
            that.page = currentPage;
            that.getList();
        },

        /**
         * 获取列表
         */
        getList() {
            let that = this;
            let formData = {};
            var curr_page = sessionStorage.getItem("curr_page");
            that.page = curr_page ? curr_page - 0 : that.page;
            formData.page = that.page;
            formData.course_id = that.id;
            formData.limit = that.limit;
        that.axios
            .post("/getCourseDownload", formData)
            .then((res) => {
                const data = (res && res.data) || {};
                that.tableData = data.data || [];
                that.count = data.total || 0;
                that.page = curr_page ? curr_page : that.page;
                curr_page ? sessionStorage.removeItem("curr_page") : "";
            })
            .catch(() => {
                that.tableData = [];
                that.count = 0;
            })
            .finally(() => {
                that.loading = false;
            });
        },
        back() {
            this.$router.push({
                path: "/course/details",
                query: {
                    id: this.id
                },
            });
        }
    },
};
</script>
<style scoped>
.flex-grow {
    flex-grow: 1;
}

.xcx-head {
    margin-bottom: 0px;
}

.flex-shrink-0 {
    flex-shrink: 0;
}

.inline-block {
    display: inline-block;
}

.thumb_images {
    width: 100%;
    height: 175px;
    border-radius: 5px;
}

.truncate {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.border-tags {
    border: 1px solid #C18958;
}

.text-tags {
    color: #C18958;
}

.text-6581A0 {
    color: #6581A0;
}


.border-bottom {
    border-bottom: 1px #ccc dashed;
}

.bg-2A2D31 {
    background-color: #2A2D31;
}

.bg-26292C {
    background-color: #26292C;
}

.txt-6F8199 {
    color: #6F8199;
}

.txt-233650 {
    color: #233650;
}

.txt-9097AB {
    color: #9097AB;
}

.data-item:hover {
    color: #3078FF;
    background: #F0F3F7;
}

.w42 {
    width: 43px;
    height: 52px;
}

.w14 {
    width: 14px;
}

.w161 {
    width: 125px;
}

.h900 {
    height: 90px;
    width: 49%;
}

.h55 {
    height: 55px;
    align-items: center;
}

.h400 {
    height: 400px;
}
</style>